import { Button, FormControlLabel, Grid, Radio, Typography } from "@mui/material";
import { addDays, parseISO } from "date-fns";
import { Form, Formik } from "formik";
import {
  useDispatch, useSelector
} from "react-redux";
import { getTiposAvisoObra } from "../../../../redux/actions/obra";
import FormikActions from "../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../commons/formik/FormikAutocomplete";
import FormikDatePicker from "../../../commons/formik/FormikDatePicker";
import FormikRadio from "../../../commons/formik/FormikRadio";
import FormikTextField from "../../../commons/formik/FormikTextField";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import { StyledNuevaObra } from "../../../styled/Obras";
import { enumTiposGestion } from "../commons/enumTipoGestion";
import useGestionObra from "../hooks/useGestionObra";
import { identificacionFormValidation } from "../validation/formValidation";
import TipoContratista from "./TipoContratista";


const IdentificacionForm = ({ handleSubmit, formModel, setFormModel, initialValues, lastFormProps, handleCancel }) => {
  const dispatch = useDispatch();
  const anteriorForm = useSelector((state) => state.obra.ultimoFormularioCargado.data);
  const diasFechaInicioObra = useSelector((state) => state.obra.diasFechaInicioObra.data);
  const [nombreTipoGestion, tiposDeGestionMemorizados] = useGestionObra(lastFormProps?.tipoAvisoObra, lastFormProps?.estado, lastFormProps?.informadoSRT);

  const esObraPrexistente = !!lastFormProps?.estado;
  const tiposContratista = useSelector((state) => state.obra.tipoContratista);
  const CONTRATISTA_DEFAULT_35 = tiposContratista.data.find(
    (e) => e.nombre == "Contratista Principal"
  );
  return (
    <Formik
      initialValues={formModel}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      validationSchema={identificacionFormValidation(lastFormProps, nombreTipoGestion, nombreTipoGestion, lastFormProps?.informadoSRT, diasFechaInicioObra, esObraPrexistente)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FechaPresentacionLabel
                date={
                  nombreTipoGestion(values.idTipoAvisoObra, true) !== enumTiposGestion.edicion
                    ? new Date()
                    : values.fechaRecepcion
                }
              />
            </Grid>
            {esObraPrexistente && (
              <>
                <StyledNuevaObra.PaddingContainer item xs={3}>
                  <StyledNuevaObra.FormikInput>
                    <FormikTextField
                      name="numeroObraSRT"
                      label="Nro. de Obra*"
                      fullWidth
                      disabled={esObraPrexistente}
                    />
                  </StyledNuevaObra.FormikInput>
                </StyledNuevaObra.PaddingContainer>
                <StyledNuevaObra.PaddingContainer item xs={4}>
                  <StyledNuevaObra.FormikInput>

                    <FormikAutocomplete
                      name="idTipoAvisoObra"
                      label="Tipo de Gestion"
                      fullWidth
                      options={tiposDeGestionMemorizados}
                      getOptions={() => dispatch(getTiposAvisoObra(lastFormProps.idGestionObra))}
                      callBack={(v) => {
                        if (v) {
                          if (v.nombre !== enumTiposGestion.extension) {
                            // Reiniciamos la fecha de extension para mostrar el valor de lectura
                            setFieldValue('fechaHastaExtensionObra', lastFormProps.ultimaFechaExtension ? lastFormProps.ultimaFechaExtension : null)
                          }
                          if (v.nombre === enumTiposGestion.suspension) {
                            let maximaFechaSuspension = Math.max(...lastFormProps.periodosSuspension.map((periodo) => periodo.fechaReinicio));
                            setFieldValue('fechaSuspension', maximaFechaSuspension !== -Infinity ? addDays(new Date(maximaFechaSuspension), 1) : null);
                            // Una nueva suspension no debe sugerir valor fin fecha suspension
                            setFieldValue('fechaFinReinicioSuspension', null);
                          } else {
                            setFieldValue('fechaFinReinicioSuspension', anteriorForm.fechaFinReinicioSuspension ? parseISO(anteriorForm.fechaFinReinicioSuspension) : null)
                          }
                        }
                      }
                      }
                    />
                  </StyledNuevaObra.FormikInput>
                </StyledNuevaObra.PaddingContainer>
                <StyledNuevaObra.PaddingContainer item xs={5}>

                </StyledNuevaObra.PaddingContainer>
              </>
            )}

            <StyledNuevaObra.PaddingContainer item xs={6}>
              <StyledNuevaObra.FormikInput>
                <FormikTextField
                  name="denominacionObra"
                  label="Nombre Otorgado a la Obra*"
                  disabled={esObraPrexistente}
                  fullWidth
                />
              </StyledNuevaObra.FormikInput>
            </StyledNuevaObra.PaddingContainer>

            <StyledNuevaObra.PaddingContainer item xs={6}>
              <StyledNuevaObra.FormikInput>
                <FormikDatePicker
                  name="fechaInicioObra"
                  disabled={!!lastFormProps?.estado && !(nombreTipoGestion(values.idTipoAvisoObra, true) === enumTiposGestion.edicion && lastFormProps.tipoAvisoObra === null)}
                  label="Fecha de Inicio de Actividad*"
                  fullWidth
                />
              </StyledNuevaObra.FormikInput>
            </StyledNuevaObra.PaddingContainer>
            <StyledNuevaObra.PaddingContainer item xs={6}>
              <StyledNuevaObra.FormikInput>
                <FormikDatePicker
                  disabled={!!lastFormProps?.estado && !(nombreTipoGestion(values.idTipoAvisoObra, true) === enumTiposGestion.edicion && lastFormProps.tipoAvisoObra === null)}
                  name="fechaFinObra"
                  label="Fecha de Fin Estimada*"
                  fullWidth
                />
              </StyledNuevaObra.FormikInput>
            </StyledNuevaObra.PaddingContainer>
            <StyledNuevaObra.PaddingContainer item xs={6}>
              <StyledNuevaObra.FormikInput>
                {
                  ((nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.extension) ||
                    ((
                      nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.suspension
                      || nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.reinicio)
                      && values.fechaHastaExtensionObra)
                  ) &&
                  <FormikDatePicker
                    name="fechaHastaExtensionObra"
                    label="Fecha Extensión Hasta*"
                    fullWidth
                    disabled={nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.suspension || nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.reinicio}
                  />
                }

              </StyledNuevaObra.FormikInput>
            </StyledNuevaObra.PaddingContainer>
            {

              (nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.suspension || nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.reinicio) && (
                <>
                  <StyledNuevaObra.PaddingContainer item xs={6}>
                    <StyledNuevaObra.FormikInput>
                      <FormikDatePicker
                        disabled={nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.reinicio}
                        name="fechaSuspension"
                        label="Fecha Suspensión Desde*"
                        fullWidth

                      />
                    </StyledNuevaObra.FormikInput>
                  </StyledNuevaObra.PaddingContainer>


                  <StyledNuevaObra.PaddingContainer item xs={6}>
                    <StyledNuevaObra.FormikInput>
                      {(nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.suspension || nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.reinicio) && (
                        <FormikDatePicker
                          disabled={nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.reinicio}
                          name="fechaFinReinicioSuspension"
                          label="Fecha Estimada Fin de Suspensión*"
                          fullWidth
                        />
                      )}
                    </StyledNuevaObra.FormikInput>
                  </StyledNuevaObra.PaddingContainer>
                </>
              )}

            {
              (nombreTipoGestion(values.idTipoAvisoObra) === enumTiposGestion.reinicio) && (
                <>
                  <StyledNuevaObra.PaddingContainer item xs={6}>
                    <StyledNuevaObra.FormikInput>
                      <FormikDatePicker
                        name="fechaReinicioSuspension"
                        label="Fecha de Reinicio*"
                        fullWidth
                      />
                    </StyledNuevaObra.FormikInput>
                  </StyledNuevaObra.PaddingContainer>
                </>
              )}


            <Grid item xs={12}>
              <Typography variant="h6">Característica de la Obra</Typography>
            </Grid>

            <StyledNuevaObra.PaddingContainer item xs={3}>
              <StyledNuevaObra.RadioContainer>
                <FormikRadio name="resolucion">
                  <FormControlLabel
                    value="5197"
                    control={<Radio disabled={esObraPrexistente} checked={values.resolucion == "5197"} />}
                    label="Resolución 51/97"
                    labelPlacement="end"
                    onChange={() =>
                      setFieldValue(
                        "idTipoContratista",
                        initialValues.idTipoContratista
                      )
                    }
                  />
                  <StyledNuevaObra.FormikRadio>
                    <FormControlLabel
                      value="3598"
                      control={<Radio disabled={esObraPrexistente} checked={values.resolucion == "3598"} />}
                      label="Resolución 35/98"
                      labelPlacement="end"
                      onChange={() =>
                        setFieldValue(
                          "idTipoContratista",
                          CONTRATISTA_DEFAULT_35.id
                        )
                      }
                    />
                  </StyledNuevaObra.FormikRadio>
                  <StyledNuevaObra.FormikRadio>
                    <FormControlLabel
                      value="319/99"
                      control={<Radio disabled={esObraPrexistente} checked={values.resolucion == "319/99"} />}
                      label="Resolución 319/99"
                      labelPlacement="end"
                      onChange={() =>
                        setFieldValue(
                          "idTipoContratista",
                          initialValues.idTipoContratista
                        )
                      }
                    />
                  </StyledNuevaObra.FormikRadio>
                </FormikRadio>
              </StyledNuevaObra.RadioContainer>
            </StyledNuevaObra.PaddingContainer>

            <StyledNuevaObra.PaddingContainer item container direction="column" xs={3}>
              <TipoContratista
                opcionesContratista={tiposContratista.data}
                values={values}
                disabled={esObraPrexistente}
              />
              <StyledNuevaObra.WarningRes319>
                {values.resolucion === '319/99' ?
                  <Typography color="error">
                    (Máximo 7 dias corridos)
                  </Typography>
                  : null
                }

              </StyledNuevaObra.WarningRes319>
            </StyledNuevaObra.PaddingContainer>

            <StyledNuevaObra.PaddingContainer
              container
              item
              xs={6}
              direction="column"
            >
              <StyledNuevaObra.FormikInput>
                <FormikTextField
                  name="superficieAConstruir"
                  label="Superficie a Construir"
                  fullWidth
                />
              </StyledNuevaObra.FormikInput>
              <StyledNuevaObra.FormikInput>
                <FormikTextField
                  name="numeroPlantas"
                  label="Nro. de Plantas"
                  fullWidth
                />
              </StyledNuevaObra.FormikInput>
            </StyledNuevaObra.PaddingContainer>
            <StyledNuevaObra.PaddingContainer item xs={12}>
              <StyledNuevaObra.ContainerMultiline>
                <FormikTextField
                  name="observaciones"
                  label="Observación de Obra"
                  variant="outlined"
                  fullWidth
                  multiline
                  maxRows={15}
                  minRows={2}
                />
                {values.observaciones.length > 0 && (
                  <Typography variant="caption">
                    {values.observaciones.length} caracteres
                  </Typography>
                )}
              </StyledNuevaObra.ContainerMultiline>
            </StyledNuevaObra.PaddingContainer>
          </Grid>
          <StyledNuevaObra.ButtonContainer>
            <Button
              onClick={handleCancel}
              color="primary"
              type="button"
            >
              Cancelar
            </Button>
            <FormikActions
              submit="Siguiente"
              disabled={
                !(
                  values.denominacionObra &&
                  values.fechaInicioObra &&
                  values.fechaFinObra &&
                  values.resolucion &&
                  values.idTipoContratista
                )
              }
            />
          </StyledNuevaObra.ButtonContainer>
        </Form>
      )
      }
    </Formik >
  );
};

export default IdentificacionForm;
